"use client";

import { c as _c } from "react/compiler-runtime";
import { buildUsrcCpsReferralAuthInstruction, resolveUsrcCpsAuthPortalPath, VA_RFS_FORM_URL } from "@/configuration/groups/usrc-cps/referral-auth-instructions";
import { ReferralAuthInstructionsCard } from "@/src/components/tasks/referral-auth-instructions-card";
import { StediEligibilitySummary } from "@/src/components/tasks/stedi-eligibility-summary";
import { useReferralAuthOpenAuthorization } from "@/src/hooks/use-referral-auth-open-authorization";
import { useStediEligibilityCheck } from "@/src/lib/data-fetchers/stedi-eligibility-check-fetchers";
import { resolveReferralAuthOnFile } from "@/src/lib/prior-authorization/referral-auth-on-file";
import type { PriorAuthorization } from "@/src/models/documents/prior-authorization/prior-authorization";
import { Referral } from "@/src/models/documents/referral";
interface UsrcCpsReferralAuthInstructionsProps {
  referral: Referral;
  linkedPriorAuthorizations: PriorAuthorization[];
  taskId: string;
  taskPriorAuthorization?: PriorAuthorization | null;
  startTrackingCaseDisabled?: boolean;
  subdomain: string;
}
export function UsrcCpsReferralAuthInstructions(t0) {
  const $ = _c(21);
  const {
    referral,
    linkedPriorAuthorizations,
    taskId,
    taskPriorAuthorization,
    startTrackingCaseDisabled: t1,
    subdomain
  } = t0;
  const startTrackingCaseDisabled = t1 === undefined ? false : t1;
  const {
    eligibilityCheck
  } = useStediEligibilityCheck(referral.id);
  let t2;
  if ($[0] !== linkedPriorAuthorizations || $[1] !== referral || $[2] !== subdomain || $[3] !== taskPriorAuthorization) {
    const authOnFile = resolveReferralAuthOnFile(referral, linkedPriorAuthorizations, taskPriorAuthorization);
    const path = resolveUsrcCpsAuthPortalPath({
      subdomain,
      primaryCoverage: referral.primaryCoverage,
      secondaryCoverage: referral.secondaryCoverage
    });
    t2 = buildUsrcCpsReferralAuthInstruction({
      path,
      authOnFile
    });
    $[0] = linkedPriorAuthorizations;
    $[1] = referral;
    $[2] = subdomain;
    $[3] = taskPriorAuthorization;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const instruction = t2;
  let t3;
  if ($[5] !== linkedPriorAuthorizations || $[6] !== taskId || $[7] !== taskPriorAuthorization) {
    t3 = {
      taskId,
      taskPriorAuthorization,
      linkedPriorAuthorizations
    };
    $[5] = linkedPriorAuthorizations;
    $[6] = taskId;
    $[7] = taskPriorAuthorization;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    handleOpenAuthorization,
    isOpeningAuthorization
  } = useReferralAuthOpenAuthorization(t3);
  let t4;
  if ($[9] !== instruction.showVaFormLink || $[10] !== instruction.text) {
    t4 = instruction.showVaFormLink ? <>{instruction.text}{" "}<a href={VA_RFS_FORM_URL} target="_blank" rel="noopener noreferrer" className="underline">VA Form 10-10172</a>.</> : instruction.text;
    $[9] = instruction.showVaFormLink;
    $[10] = instruction.text;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const instructionNode = t4;
  const t5 = startTrackingCaseDisabled ? "Finish updating the task before opening authorization tracking." : "Opens the authorization in the Authorizations tab to track status.";
  const t6 = startTrackingCaseDisabled || isOpeningAuthorization;
  let t7;
  if ($[12] !== eligibilityCheck) {
    t7 = eligibilityCheck ? <StediEligibilitySummary check={eligibilityCheck} /> : null;
    $[12] = eligibilityCheck;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== handleOpenAuthorization || $[15] !== instructionNode || $[16] !== isOpeningAuthorization || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <ReferralAuthInstructionsCard instruction={instructionNode} openButtonTooltip={t5} isOpenButtonDisabled={t6} isOpening={isOpeningAuthorization} onOpenAuthorization={handleOpenAuthorization} footer={t7} />;
    $[14] = handleOpenAuthorization;
    $[15] = instructionNode;
    $[16] = isOpeningAuthorization;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}